import { useStore } from 'effector-react'
import { RegistrationStepsEnum } from '../constant'
import { $currentStep } from '../stepModel'
import { FixWrapper, Step } from './styled'

export function Steps() {
  const currentStep = useStore($currentStep)

  return (
    <FixWrapper>
      {[
        RegistrationStepsEnum.PASSPORT_STEP,
        RegistrationStepsEnum.DRIVER_LICENSE_STEP,
        RegistrationStepsEnum.ADDITIONAL_DATA,
      ].map((step, index) => (
        <Step
          data-testid={
            step === currentStep ? `step-${step}-active` : `step-${step}`
          }
          key={step}
          $selected={step === currentStep}
          style={index === 0 ? { paddingRight: '1px' } : {}}
        >
          {index + 1}
        </Step>
      ))}
    </FixWrapper>
  )
}
